'use client';

import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { QRCodeSVG } from 'qrcode.react';

interface QrCodeProps {
  value: string;
  size?: number;
  title?: string;
  /**
   * QR error-correction level. Defaults to 'M' (~15% recovery) so codes stay
   * scannable through screen glare or partial occlusion. Bump to 'Q'/'H' only
   * if the encoded link is short enough to keep modules large.
   */
  level?: 'L' | 'M' | 'Q' | 'H';
  sx?: SxProps<Theme>;
  'data-cy'?: string;
}

const QrCode = ({
  value,
  size = 84,
  title = 'QR code',
  level = 'M',
  sx,
  'data-cy': dataCy = 'qr-code',
}: QrCodeProps) => (
  <Box
    data-cy={dataCy}
    sx={[
      {
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: '#FFFFFF',
        lineHeight: 0,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <QRCodeSVG
      value={value}
      title={title}
      size={size}
      level={level}
      marginSize={4}
      bgColor="#FFFFFF"
      fgColor="#000000"
      style={{ display: 'block', width: '100%', height: '100%' }}
    />
  </Box>
);

export default QrCode;
